<template>
  <div class="border sm:flex my-4 py-3 bg-white" v-if="stats">
    <div class="sm:w-1/3 md:w-1/4 text-center self-center">
      <div class="flex text-lg justify-center p-3 md:p-0">
        <div class="font-semibold mr-2">{{ stats.total }}</div>
        <div class="text-gray-500">Accounts</div>
      </div>
    </div>
    <div class="sm:w-1/3 md:w-1/4 text-center self-center">
      <div class="flex text-lg justify-center p-3 md:p-0 border-l">
        <div class="font-semibold mr-2">{{ stats.active }}</div>
        <div class="text-gray-500">Actief</div>
      </div>
    </div>
    <div class="sm:w-1/3 md:w-1/4 text-center self-center">
      <div class="flex text-lg justify-center p-3 md:p-0 border-l">
        <div class="font-semibold mr-2">{{ stats.verified }}</div>
        <div class="text-gray-500">Geactiveerd</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stats: {
      type: Object
    }
  }
};
</script>
